export const useSxStyles = () => {
  return {
    checkbox: {
      padding: '3px 6px',
      border: '1px solid #ccc',
      borderRadius: '4px',
      fontSize: '14px',
    },
    option: {
      display: 'inline-block',
      fontSize: '14px',
    },
  };
};
